import { Component, OnInit, ViewChild, PLATFORM_ID, NgZone } from '@angular/core';
import { ViewobserverService } from './service/viewobserver.service';
import { OauthService} from './service/oauth.service';
import { AngularFireAuth } from '@angular/fire/auth';
import { Router } from '@angular/router';
import { UserInterface } from './models/user';
import { AlarmInterface } from './models/alarm';
import { AlarmsqueryService } from './service/alarmsquery.service';
import { MatSidenav, MatDrawer } from '@angular/material/sidenav';
import { MatSnackBar } from '@angular/material/snack-bar';
import { BQRequestService } from './service/bqrequest.service';
import { MarkersService } from './service/markers.service';
import { TelemetryService } from './service/telemetry.service';
import { FormControl } from '@angular/forms';
import { isUndefined } from 'util';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})


export class AppComponent implements OnInit{

  Configs =  {
    'bancointernacional': {
      apiKey: "AIzaSyA9uZ6Y34r8PQuIXDHmeHOPk4Br1Yl_R68",
      authDomain: "bancointernacional.firebaseapp.com",
      databaseURL: "https://bancointernacional.firebaseio.com",
      projectId: "bancointernacional",
      storageBucket: "bancointernacional.appspot.com",
      messagingSenderId: "504435767523"
    },
    'grupokfc-casa-res':
    {
      apiKey: "AIzaSyDAtv2OVhmu77GbecHBd7r3xsz8pa0H17Q",
      authDomain: "grupokfc-casa-res.firebaseapp.com",
      databaseURL: "https://grupokfc-casa-res.firebaseio.com",
      projectId: "grupokfc-casa-res",
      storageBucket: "grupokfc-casa-res.appspot.com",
      messagingSenderId: "614427835613"
    },
    'gentecsandbox':
    {
      apiKey: "AIzaSyD0V4nzj9Ay9bldK9_lvuce7qid6auhWWs",
      authDomain: "gentecsandbox.firebaseapp.com",
      databaseURL: "https://gentecsandbox.firebaseio.com",
      projectId: "gentecsandbox",
      storageBucket: "gentecsandbox.appspot.com",
      messagingSenderId: "704044488873"
    },
    'genteccloud':
    {
      apiKey: "AIzaSyAGBe-hMFDSFTN13xa2d7FCKM5Vz9a8GWk",
      authDomain: "genteccloud.firebaseapp.com",
      databaseURL: "https://genteccloud.firebaseio.com",
      projectId: "genteccloud",
      storageBucket: "genteccloud.appspot.com",
      messagingSenderId: "76770980611"
    },
    'concesionarioschevrolet':
    {
      apiKey: "AIzaSyAwUdBA1EU8dYuet-EZhrjeBuZjdmt_X3c",
      authDomain: "concesionarioschevrolet.firebaseapp.com",
      databaseURL: "https://concesionarioschevrolet.firebaseio.com",
      projectId: "concesionarioschevrolet",
      storageBucket: "concesionarioschevrolet.appspot.com",
      messagingSenderId: "819278583554"
    },
    'grupokfc-cajun':
    {
      apiKey: "AIzaSyCya8k2e-TZzxw8sCOjmbmByqEYD-sEo4Q",
      authDomain: "grupokfc-cajun.firebaseapp.com",
      databaseURL: "https://grupokfc-cajun-default-rtdb.firebaseio.com",
      projectId: "grupokfc-cajun",
      storageBucket: "grupokfc-cajun.appspot.com",
      messagingSenderId: "176989655074"
    },
    'farmaenlace':
    {
      apiKey: "AIzaSyA4FaHy8F-msNAp7fZHPRnfTU5MQjlPlP8",
      authDomain: "farmaenlace.firebaseapp.com",
      databaseURL: "https://farmaenlace-default-rtdb.firebaseio.com",
      projectId: "farmaenlace",
      storageBucket: "farmaenlace.appspot.com",
      messagingSenderId: "437441871795"
    },
    'veris-gentec':
    {
      apiKey: "AIzaSyBI9i-17ifCS96-IXZNE81DrkKy8X-FzTE",
      authDomain: "veris-gentec.firebaseapp.com",
      databaseURL: "https://veris-gentec-default-rtdb.firebaseio.com",
      projectId: "veris-gentec",
      storageBucket: "veris-gentec.appspot.com",
      messagingSenderId: "95620598726",
      appId: "1:95620598726:web:6f5bb78ffeb41b34a240c7"
    },
    'gentec-pms':{
      apiKey: "AIzaSyCTiRiM-fOwe4vW5rZGBpqWv7MJ4nHQkAQ",
      authDomain: "gentec-pms.firebaseapp.com",
      databaseURL: "https://gentec-pms-default-rtdb.firebaseio.com",
      projectId: "gentec-pms",
      storageBucket: "gentec-pms.appspot.com",
      messagingSenderId: "467192487861",
      appId: "1:467192487861:web:483f94cc9809b2211c43fc"
    }
    ,
    'bebemundo':{
      apiKey: "AIzaSyCMWvPvhnB6aEaYOpwQ1lrgky_Coewqi00",
      authDomain: "bebemundo.firebaseapp.com",
      databaseURL: "https://bebemundo-default-rtdb.firebaseio.com",
      projectId: "bebemundo",
      storageBucket: "bebemundo.appspot.com",
      messagingSenderId: "378640300274",
      appId: "1:378640300274:web:cb756c2093e65c8875f86b"
    },
    'pacho-salas':
    {
      apiKey: "AIzaSyCEgveSl--lBECWiaBoSxh5DuRacjSTZEg",
      authDomain: "pacho-salas.firebaseapp.com",
      databaseURL: "https://pacho-salas-default-rtdb.firebaseio.com",
      projectId: "pacho-salas",
      storageBucket: "pacho-salas.appspot.com",
      messagingSenderId: "70336572177",
      appId: "1:70336572177:web:0eb6a01d14b16353863ab0"
    },
    'audi-cumbaya':
    {
      apiKey: "AIzaSyDvsakcrwxK6VBanU5va3qY9D5jXiph_hU",
      authDomain: "audi-cumbaya.firebaseapp.com",
      databaseURL: "https://audi-cumbaya-default-rtdb.firebaseio.com",
      projectId: "audi-cumbaya",
      storageBucket: "audi-cumbaya.appspot.com",
      messagingSenderId: "1076832621214",
      appId: "1:1076832621214:web:918bf971e878ee35e9a18f"
    },
    'mazda-cumbaya':
    {
      apiKey: "AIzaSyDTqnc5BUDzxI65TNynBwqgvehPOD9JNco",
      authDomain: "mazda-cumbaya.firebaseapp.com",
      databaseURL: "https://mazda-cumbaya-default-rtdb.firebaseio.com",
      projectId: "mazda-cumbaya",
      storageBucket: "mazda-cumbaya.appspot.com",
      messagingSenderId: "830475305755",
      appId: "1:830475305755:web:8349378b31bf213de0c9be"
    },
    'residencia-vergara':
    {
      apiKey: "AIzaSyCYKUGp4HvlTns3GFLCL7Pz4pwqz0mx0kg",
      authDomain: "residencia-vergara.firebaseapp.com",
      databaseURL: "https://residencia-vergara-default-rtdb.firebaseio.com",
      projectId: "residencia-vergara",
      storageBucket: "residencia-vergara.firebasestorage.app",
      messagingSenderId: "475971496388",
      appId: "1:475971496388:web:fe653c7bb61947b6d81c91"
    },
    'chery-cumbaya':
    {
      apiKey: "AIzaSyAk-pLQirhYK1c2RWDPgNv37BlWfaJCOPE",
      authDomain: "chery-cumbaya.firebaseapp.com",
      databaseURL: "https://chery-cumbaya-default-rtdb.firebaseio.com",
      projectId: "chery-cumbaya",
      storageBucket: "chery-cumbaya.firebasestorage.app",
      messagingSenderId: "343380051432",
      appId: "1:343380051432:web:26fc48d02bda34f85b905d"
    },
    'oficina-quito':
    {
      apiKey: "AIzaSyBkpwAXc2zGfMQh3mdwiAEU28DOD7_oLCk",
      authDomain: "oficina-quito.firebaseapp.com",
      databaseURL: "https://oficina-quito-default-rtdb.firebaseio.com",
      projectId: "oficina-quito",
      storageBucket: "oficina-quito.firebasestorage.app",
      messagingSenderId: "554472964333",
      appId: "1:554472964333:web:ce8ef18cff73d784d80ce4"
    },
    'dolce-incontro':{
      apiKey: "AIzaSyB29jWv5kOsiV9LHBM4aQRkRFeAXP2sn2A",
      authDomain: "dolce-incontro.firebaseapp.com",
      databaseURL: "https://dolce-incontro-default-rtdb.firebaseio.com",
      projectId: "dolce-incontro",
      storageBucket: "dolce-incontro.firebasestorage.app",
      messagingSenderId: "26324770509",
      appId: "1:26324770509:web:3e5c70749cb6f92a865384"
    },
    "barrio-guayaquil":{
      apiKey: "AIzaSyDKaMcYgXsZPh3nuhmx4acjKpnlzSwfMrE",
      authDomain: "barrio-guayaquil.firebaseapp.com",
      databaseURL: "https://barrio-guayaquil-default-rtdb.firebaseio.com",
      projectId: "barrio-guayaquil",
      storageBucket: "barrio-guayaquil.firebasestorage.app",
      messagingSenderId: "84356729580",
      appId: "1:84356729580:web:b87df6c94cf1b46480f3c9"
    },
    "parami-recreo":{
      apiKey: "AIzaSyD9qf8Vx9qh9filtF_w6PXkURuSn8-whj8",
      authDomain: "parami-recreo.firebaseapp.com",
      databaseURL: "https://parami-recreo-default-rtdb.firebaseio.com",
      projectId: "parami-recreo",
      storageBucket: "parami-recreo.firebasestorage.app",
      messagingSenderId: "339489582452",
      appId: "1:339489582452:web:3430317e079bb305701021"
    },
    "peaje-cosad25":{
      apiKey: "AIzaSyDO-2ZyjkYV0_EY_ldvA8IhLkEDMczJfUE",
      authDomain: "peaje-cosad25.firebaseapp.com",
      databaseURL: "https://peaje-cosad25-default-rtdb.firebaseio.com",
      projectId: "peaje-cosad25",
      storageBucket: "peaje-cosad25.firebasestorage.app",
      messagingSenderId: "50100499906",
      appId: "1:50100499906:web:f46b9f2e90d21c46aed25b"
    }
  



    //BoXGoYQyUkN1DIkxpUZdDxc3j5x1

  }

  public array: any[] = [];
  public notifics: AlarmInterface[];
  public nots: number;
  public siteName = '-';
  public ProjectSelector = new FormControl();
  public ProjectSelected = '';
  public enabled_proyects = [];
  public selectedProyect = {};
  public date: Date = new Date();
  public isGranted: any = false;
  public isAdmin: any = false;
  public userUid: string = null;
  public isMobile: boolean = false;
  public zone: string = null;
  public city: string = null;
  public office: string = null;
  public alarmsSub;

  user: UserInterface = {
    name: '',
    photoUrl: '',
    isLogged: false,
    email: '',
    roles: {
      viewer: false,
      admin: false,
    },
  };

  @ViewChild('drawer', { static: true }) sidenav: MatDrawer;

  ngOnInit() {

    this.getCurrentUser();

    //observer to get view size
    this.observer.getMode().subscribe(result =>{
      this.isMobile = result.matches;
      this.drawerToggle(true);
    })

    // //observer to get nots
    // this.alarmService.getAlarmsRT().subscribe(result =>{
    //   this.array = [];
    //   if (typeof result !== "undefined"){
    //     result.forEach(element => {
    //       this.array.push(Object.values(element));
    //     });
    //     this.nots= this.array.length;
    //     if (this.nots == 0){
    //       this.nots = null;
    //     };
    //   }
    // })

    this.delay(900).then(any=>{
      let dummy= this.router.url.split(';');
      if (dummy[0] == '/history')
        {
          document.getElementById('ab').className = 'nav-options mat-button selected';
        }

      if (this.router.url == '/indices')
        {
          document.getElementById('ab').className = 'nav-options mat-button selected';
        }

      if (this.router.url == '/alarms')
        {
          document.getElementById('ab').className = 'nav-options mat-button selected';
        }
    })

  }

  drawerToggle(state: boolean){
    if (state){this.sidenav.close();this.sidenav.mode='over';};

    if (!state){this.sidenav.open();this.sidenav.mode='over';};

  }

  constructor(public router: Router,
    private authService: OauthService,
    private observer: ViewobserverService,
    private afsAuth: AngularFireAuth,
    private Zone: NgZone,
    private alarmService: AlarmsqueryService,
    private bqrequest: BQRequestService,
    private markers: MarkersService,
    private tservice: TelemetryService,
    private snackBar: MatSnackBar){
      setInterval(() => {
        this.date = new Date();
      }, 60);

    }

  getCurrentUser(){
    this.router.navigateByUrl('');
    this.authService.isAuth().subscribe( user => {
    if (user)
    {
      this.user.isLogged = true;
      this.user.name = user.displayName;
      this.user.photoUrl = user.photoURL;
      this.userUid = user.uid;
      console.log('User Logged as: ', this.user.name);
      this.snackBar.open('Bienvenido de nuevo '+this.user.name, 'x', {duration: 3000, verticalPosition: 'top'});
      let roles = this.authService.isUserGranted(this.userUid).subscribe(userRole => {
        this.enabled_proyects = userRole['Enb_Proyects'];
        console.log(this.enabled_proyects);
        if(this.enabled_proyects === undefined)
        {
          this.delay(3500).then(any=>{
            this.snackBar.open(this.user.name+'. Su usuario no esta habilitado para usar el sistema, pongase en contacto con su proveedor, se cerrara la sesion....', 'x', {duration: 5000, verticalPosition: 'top'});
            this.delay(5500).then(any=>{
              this.authService.logoutUser();
              this.router.navigateByUrl('/login');
            })
          })
        }
        else
        {
          this.ProjectSelected = userRole['preferences']['alias'];
          this.selectedProyect = userRole['preferences'];
          this.siteName = this.selectedProyect['alias'];
          this.bqrequest.setupFirebase(this.selectedProyect['id']);
          this.markers.initFirebase(this.Configs[this.selectedProyect['id']], this.selectedProyect['id']);
          this.alarmService.setupFirebase(this.Configs[this.selectedProyect['id']], this.selectedProyect['id']);
          this.tservice.UpdateProyect(this.Configs[this.selectedProyect['id']], this.selectedProyect['id']);
          //observer to get nots
          this.alarmsSub = this.alarmService.getAlarmsRT().subscribe(result =>{
            this.array = [];
            if (typeof result !== "undefined"){
              result.forEach(element => {
                this.array.push(Object.values(element));
              });
              this.nots= this.array.length;
              if (this.nots == 0){
                this.nots = null;
              };
            }
          })
          this.router.navigateByUrl('home');
        }

        this.isGranted = Object.assign({}, userRole.roles);
        this.isGranted = this.isGranted.viewer;
        if(this.isGranted == false)
        {
          this.snackBar.open(this.user.name+'. No esta habilitado para usar el sistema, pongase en contacto con su proveedor, se cerrara la sesion....', 'x', {duration: 5000, verticalPosition: 'top'});
          this.delay(5500).then(any=>{
            this.authService.logoutUser();
            this.router.navigateByUrl('/login');
          })
        };

        this.isAdmin = Object.assign({}, userRole.roles);
        this.isAdmin = this.isAdmin.admin;
        roles.unsubscribe();
      })

      //this.router.navigateByUrl('');
    }
    else
    {
      console.log('not logged');
      this.user.isLogged = false;
      this.isAdmin = false;
      this.isGranted = false;
      this.router.navigateByUrl('/login');
    }
    })
  }

  isHistory(url: string){
    let dummy= url.split(';');
    if (dummy[0] == '/history')
      {return true}
    else
      {return false}
  }

  onLogout(){
    this.authService.logoutUser();
    this.router.navigateByUrl('/login');
  }

  justprint(){
    if(this.router.url != '/indices')
    {
      document.getElementById('bar').style.display = 'none';
      window.resizeTo(950,1550)
      window.print();
      document.getElementById('bar').style.display = 'flex';
    }
    else
    {
      window.open("https://datastudio.google.com/s/mSIKFMcZOx0","_self")
    }
   }

  changeProject(){

    this.router.navigateByUrl('');
    this.alarmsSub.unsubscribe();
    this.delay(50).then(() =>{ //espera propagacion de datos en selector
      this.ProjectSelected = this.ProjectSelector.value['alias'];
      this.selectedProyect = this.ProjectSelector.value;
      console.log(this.selectedProyect);
      this.authService.updatePreference(this.userUid, {'alias': this.ProjectSelected, 'id': this.selectedProyect['id']});
      this.siteName = this.selectedProyect['alias'];
      this.bqrequest.setupFirebase(this.selectedProyect['id']);
      this.markers.initFirebase(this.Configs[this.selectedProyect['id']], this.selectedProyect['id']);
      this.alarmService.setupFirebase(this.Configs[this.selectedProyect['id']], this.selectedProyect['id']);
      this.tservice.UpdateProyect(this.Configs[this.selectedProyect['id']], this.selectedProyect['id']);

      //observer to get nots
      this.alarmsSub = this.alarmService.getAlarmsRT().subscribe(result =>{
        this.array = [];
        if (typeof result !== "undefined"){
          result.forEach(element => {
            this.array.push(Object.values(element));
          });
          this.nots= this.array.length;
          if (this.nots == 0){
            this.nots = null;
          };
        }
      })
      this.router.navigateByUrl('home');
    })

  }

  //funcion de delay
  async delay(ms: number) {
    await new Promise<void>(resolve => setTimeout(()=>resolve(), ms)).then(()=> null);
  }

}
